import { render } from "./Payouts.vue?vue&type=template&id=0de9f50d&ts=true"
import script from "./Payouts.vue?vue&type=script&lang=ts"
export * from "./Payouts.vue?vue&type=script&lang=ts"

import "./Payouts.vue?vue&type=style&index=0&id=0de9f50d&lang=scss"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTable,QTd});
